// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"ef87c227","21":"5f20ef39","464":"1c3b2f65","606":"4cca1134","652":"4cca1134","825":"736c1854","914":"4cca1134","984":"86988593"}[chunkId] + ".chunk.css";
};